/**
 * Checks if a value is a valid array.
 * @param {any} arr - The value to be checked for validity as an array.
 * @returns {boolean} - True if the value is a valid array, false otherwise.
 */
export const strictValidArray = arr => {
  return arr && Array.isArray(arr);
};

/**
 * Checks if an array is valid and has the required length.
 * @param {Array} arr - The array to be validated.
 * @param {number} requiredLength - The required length for the array.
 * @returns {boolean} - True if the array is valid and has the required length, otherwise false.
 */
export const strictValidArrayWithMinLength = (arr, minLength = 1) => {
  return arr && Array.isArray(arr) && arr.length >= minLength;
};

/**
 * Checks if a value is a valid non-empty string.
 * @param {any} str - The value to be checked.
 * @returns {boolean} - True if the value is a valid non-empty string, false otherwise.
 */
export const strictValidString = str => {
  return !!str && typeof str === "string";
};


/**
 * Checks if a value is a valid non-empty string and have length.
 * @param {any} str - The value to be checked.
 * @param {number} requiredLength - The required length for the array.
 * @returns {boolean} - True if the value is a valid non-empty string, false otherwise.
 */
export const strictValidStringWithMinLength = (str, requiredLength = 1) => {
  return strictValidString(str) && str.length >= requiredLength;
};


/**
 * Validates if a given set of keys are present in an object.
 * @param {object} obj - The object to be checked.
 * @param {string[]} keys - An array of keys to be checked for presence in the object.
 * @returns {boolean} - True if all keys are present, false otherwise.
 */
export const validObjectWithParameterKeys = (obj, keys) => {
  if (!(strictValidObject(obj) && strictValidArrayWithMinLength(keys))) {
    return false;
  }

  for (const key of keys) {
    if (!(key in obj)) {
      return false;
    }
  }

  return true;
};


/**
 * Checks if a value is a valid plain JavaScript object (excluding arrays and other specific types).
 * @param {any} obj - The value to be checked.
 * @returns {boolean} - True if the value is a valid plain JavaScript object, false otherwise.
 */
export const strictValidObject = obj => obj && obj === Object(obj) &&
	Object.prototype.toString.call(obj) !== '[object Array]';



export const strictValidObjectWithKeys = obj => {
  return (
    strictValidObject(obj) && strictValidArrayWithMinLength(Object.keys(obj))
  );
};

export const blobEncodedToBase64 = blob => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}







// WEBPACK FOOTER //
// ./src/utils/common.js